const details = {
    name: "گالری طلا و جواهر بهسا",
    enName: "shop",
    description: "گالری طلا و جواهر بهسا",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: " طراحی سایت طلا فروشی ",
        link: "https://barantm.com/article/%D8%B7%D8%B1%D8%A7%D8%AD%DB%8C-%D8%B3%D8%A7%DB%8C%D8%AA-%D8%B7%D9%84%D8%A7-%D9%88-%D8%AC%D9%88%D8%A7%D9%87%D8%B1%D8%A7%D8%AA-%D8%AF%D8%B1-%DA%A9%D8%B1%D8%AC"
    }
}

export default details;
